module.exports = __webpack_public_path__ + "img/sinpe-movil-2.b350c34b.png";